import { useLocalStorage } from 'react-use';

const IMPERSONATE_STORAGE_KEY = 'upominej:impersonate';
export const useImpersonateStorage = () => {
  const [value, setValue, remove] = useLocalStorage(IMPERSONATE_STORAGE_KEY, '', { raw: true });
  return {
    value,
    setValue,
    remove,
  };
};
